import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { CartItem } from '@/types/cart.types';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import {
  AddMoreProceduresDestination,
  CartOrigin,
} from '@/types/enums/analytics/cart/cart-analytics.enum';
import { getCartTotal } from '@/utils/cart/get-cart-total.util';

export function trackCartOpened(origin: CartOrigin, items: CartItem[]): void {
  getAnalyticsPlugin().track(AnalyticsEnum.OPEN_CART, {
    origem: origin,
    qtd_itens: items.length,
    valor_total: getCartTotal(items),
  });
}

export function trackAddMoreProcedures(
  origin: CartOrigin,
  items: CartItem[],
  destination: AddMoreProceduresDestination,
): void {
  getAnalyticsPlugin().track(AnalyticsEnum.ADD_MORE_PROCEDURES, {
    origem: origin,
    qtd_itens: items.length,
    destino: destination,
  });
}
